import { Role, UserProp } from "app/GraphqlGeneratedTypes/types";

const authorize = (userRoles: Role[], authorizationRoles: string | string[]) => {
	const sanitizedUserRoles = userRoles?.map((role) => {
		if (typeof role !== "string") {
			return role.name;
		}

		return role;
	});

	if (typeof authorizationRoles === "string") {
		return sanitizedUserRoles?.includes(authorizationRoles);
	}

	let result = false;

	for (let i = 0; i < authorizationRoles.length; i += 1) {
		const authorizationRole = authorizationRoles[i];

		const tempResult = sanitizedUserRoles?.includes(authorizationRole);

		if (tempResult) {
			result = tempResult;
			break;
		}
	}

	return result;
};

const authorizationRoles = {
	BASIC: "Basic" as const,
	ADMIN: "Admin" as const,
	COMPANY: "Company" as const,
	SUPPLIERANALYTICSSUBSCRIBER: "SupplierAnalyticsSubscriber" as const,
	MARKETANALYTICSSUBSCRIBER: "MarketAnalyticsSubscriber" as const,
	SITESELECTORSUBSCRIBER: "SiteSelectorSubscriber" as const,
	SUPERADMIN: "SuperAdmin" as const,
	RESEARCHMANAGER: "ResearchManager" as const
};

const authorizationRolesIds = {
	Basic: 1,
	Admin: 2,
	Company: 3,
	SupplierAnalyticsSubscriber: 5,
	MarketAnalyticsSubscriber: 6,
	SiteSelectorSubscriber: 7,
	SuperAdmin: 9,
	ResearchManager: 10
};

const checkForMarketAnalyticsAccess = (user: UserProp | null) => {
	if (!user?.roles?.length) {
		throw new Error("Insufficient user data!");
	} else {
		return authorize(
			user.roles,
			[
				authorizationRoles.SUPERADMIN,
				authorizationRoles.ADMIN,
				authorizationRoles.MARKETANALYTICSSUBSCRIBER
			]
		);
	}
};

const checkForSiteSelectorAccess = (user: UserProp | null) => {
	if (!user?.roles?.length) {
		throw new Error("Insufficient user data!");
	} else {
		return authorize(
			user.roles,
			[
				authorizationRoles.ADMIN,
				authorizationRoles.SUPERADMIN,
				authorizationRoles.SITESELECTORSUBSCRIBER
			]
		);
	}
};

const checkForSupplierAnalyticsAccess = (user: UserProp | null) => {
	if (!user?.roles?.length) {
		throw new Error("Insufficient user data!");
	} else {
		return authorize(
			user.roles,
			[
				authorizationRoles.ADMIN,
				authorizationRoles.SUPERADMIN,
				authorizationRoles.SUPPLIERANALYTICSSUBSCRIBER
			]
		);
	}
};

type RoleType = (typeof authorizationRoles)[keyof typeof authorizationRoles];

export {
	authorize,
	authorizationRoles,
	authorizationRolesIds,
	checkForMarketAnalyticsAccess,
	checkForSiteSelectorAccess,
	checkForSupplierAnalyticsAccess,
	RoleType
};
